<template>
    <b-overlay :show="getting" opacity="1" :class="getting ? 'overflow-hidden' : null" rounded>
        <b-modal id="create-answer-option" title="Yeni Cevap Seçeneği" no-close-on-esc no-close-on-backdrop>
            <answer-option-create v-model="answerOption"></answer-option-create>
            <template #modal-footer><v-executer :loading="loading" :action="createAnswerOption"></v-executer></template>
        </b-modal>
        <div class="row">
            <div class="col-md-3">
                <b-card body-class="p-1" class="mb-1">
                    <div class="row align-items-end">
                        <div class="col">
                            <label class="form-label">Form İsmi</label>
                            <input class="form-control" placeholder="Form İsmi" v-model="formName"/>
                        </div>
                        <div class="col-auto">
                            <v-executer :loading="formLoading" :action="createOrUpdateForm">{{ formId ? 'Güncelle' : 'Oluştur' }}</v-executer>
                        </div>
                    </div>
                </b-card>
                <b-card body-class="p-1" v-if="formId">
                    <div class="row">
                        <div class="col-12 mb-1" v-if="connectedQuestionAnswers.length > 0">
                            <label class="form-label">Cevaba Bağlı Soru</label>
                            <v-select-list placeholder="Cevaba Bağlı Soru" label="Name" :options="connectedQuestionAnswers" :disabled="questionCreating" v-model="conditionalAnswer"></v-select-list>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Soru</label>
                            <textarea class="form-control resize-none" :disabled="questionCreating" v-model="question.Title" placeholder="Soru" rows="2"></textarea>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Cevap Türü</label>
                            <v-select-list placeholder="Cevap Türü" label="Name" :options="answerTypes" :disabled="questionCreating" v-model="answerType" v-on:input="onTypeSelect"></v-select-list>
                        </div>
                        <div class="col-12 mb-1" v-if="$safe(answerType,'Code') == 'CS' || $safe(answerType,'Code') == 'D'">
                            <label class="form-label">Cevap Seçenekleri</label>
                            <div class="d-flex g-50">
                                <v-select-list class="w-100" placeholder="Cevap Seçenekleri" multiple label="Value" :options="answers" v-model="answer" :disabled="answerType == null || (answers || []).length == 0 || questionCreating"></v-select-list>
                                <button v-if="$safe(answerType,'Code') == 'CS' || $safe(answerType,'Code') == 'D'" v-on:click="$showModal('create-answer-option')" class="btn btn-outline-primary">Ekle</button>
                            </div>
                        </div>
                        <div class="col-12">
                            <b-form-checkbox v-model="question.Required" :disabled="questionCreating">Zorunlu</b-form-checkbox>
                        </div>
                        <div class="col-12 text-right">
                            <v-executer :action="createQuestion" :loading="questionCreating" :disabled="!canAdd">Soruyu Ekle</v-executer>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="col-md-9">
                <div class="row">
                    <template v-if="($safe(form,'Questions') ||[]).length > 0">
                        <div v-for="(q,i) in (form.Questions ||[])" :key="i" class="col-md-4 mb-1">
                            <b-card class="h-100 border" :class="$safe(conditionalAnswer,'QuestionId') == q.Id ? 'border-secondary' :''" body-class="p-1 d-flex align-items-start">
                                <div class="d-flex w-100 h-100 flex-column">
                                    <h4 class="mb-50">{{i+1}}. {{ $safe(q,'Title') }}</h4>
                                    <template v-if="q.AnswerOptions.length != 0">
                                        <div class="text-muted border-bottom mb-25 w-100">Cevaplar</div>
                                        <div class="d-flex g-50">
                                            <b-badge :variant="$safe(conditionalAnswer,'Id') == ao.AnswerOptionOfQuestionId ? 'secondary' : 'dark'" v-for="(ao,ii) in q.AnswerOptions" :key="ii">{{ ao.Value }}</b-badge>
                                        </div>
                                    </template>
                                    <div v-else>
                                        Açık Uçlu
                                    </div>
                                    <template v-if="getRelatedAnswer(q)">
                                        <span class="text-secondary mt-auto">{{ getRelatedAnswer(q) }}</span>
                                        <div :class="['font-weight-bolder',{'text-danger':q.Required,'text-info':!q.Required}]">{{ q.Required ? 'Zorunlu' : 'Zorunlu Değil' }}</div>    
                                    </template>
                                    <template v-else>
                                        <div :class="['font-weight-bolder mt-auto',{'text-danger':q.Required,'text-info':!q.Required}]">{{ q.Required ? 'Zorunlu' : 'Zorunlu Değil' }}</div>    
                                    </template> 
                                </div>
                                <button v-on:click="deleteQ(q)" class="btn btn-outline-danger btn-xs btn-icon ml-auto"><feather-icon icon="TrashIcon"/></button>
                            </b-card>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-12 mb-1">
                            Henüz soru eklenmemiştir.
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BCard, BFormCheckbox, BOverlay, BBadge } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import AnswerOptionCreate from './components/AnswerOptionCreate.vue';

export default {
    components:{
        BCard,
        BFormCheckbox,
        BOverlay,
        BBadge,
        AnswerOptionCreate
    },
    data(){
        return {
            form:null,
            formId:this.$route.params.id !=0 ? this.$route.params.id : null,
            formName:null,
            formLoading:false,
            questionCreating:false,
            getting:false,
            question:{
                Title: null,
                Required: false
            },
            answerTypes:[],
            answerType:null,
            answers:[],
            answer:[],
            conditionalAnswer:null,
            loading:false,
            answerOption:{
                AnswerTypeId:null,
                Value:null,
                DescriptionRequired:false,
            }
        }
    },
    mounted(){
        this.getAnswerTypes()
        this.getForm()
    },
    methods:{
        createAnswerOption(){
            this.loading = true
            EmployeeOperationsApi.Form.AnswerOptionCreate({
                AnswerTypeId:this.answerType?.Id || null,
                Value:this.answerOption.Value,
                DescriptionRequired:this.answerOption.DescriptionRequired,
            }).then(res => {
                if(res.data.Success){
                    this.$hideModal('create-answer-option')
                    this.onTypeSelect()
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        createOrUpdateForm(){
            this.formLoading = true
            EmployeeOperationsApi.Form.CreateOrUpdate(this.formId != null,{
                Id:this.formId,
                Name:this.formName
            }).then(res => {
                if(res.data.Success){
                    this.$result(res)
                    this.formId = res.data.Data
                }
                this.formLoading = false
            }).catch(err => {
                this.formLoading = false
                this.$result(null,err)
            })
        },
        getForm(){
            if(this.formId){
                this.getting = true
                EmployeeOperationsApi.Form.Get(this.formId).then(res => {
                    if(res.data.Success){
                        this.form = res.data.Data
                        this.formName = res.data.Data.Name
                    }else{
                        this.$result(null,res)
                    }
                    this.getting = false
                }).catch(err => {
                    this.$result(null,err)
                    this.getting = true
                })
            }
        },
        createQuestion(){
            this.questionCreating = true
            EmployeeOperationsApi.Form.QuestionCreate({
                Title: this.question.Title,
                FormId: this.formId,
                AnswerOptions: (this.answer || []).map(a => a.Id) || [],
                Required: this.question.Required,
                ConditionalAnswerOptionId:this.conditionalAnswer?.Id || null
            }).then(res=> {
                if(res.data.Success){
                    this.getForm()
                    this.question.Title = null
                    this.question.Required = false
                    this.answers = []
                    this.answer = []
                    this.answerType = null
                    this.conditionalAnswer = null
                }
                this.$result(res)
                this.questionCreating = false
            }).catch(err => {
                this.questionCreating = false
            })
        },
        getAnswerTypes(){
            EmployeeOperationsApi.Form.AnswerTypeList().then(res => {
                this.answerTypes = res.data.Data ||[]
            })
        },
        onTypeSelect(){
            if(this.answerType?.Id){
                this.answer = []
                EmployeeOperationsApi.Form.AnswerByTypeId(this.answerType.Id).then(res => {
                    this.answers = res.data.Data
                })
            }
        },
        getRelatedAnswer(q){
            if(this.form?.Questions && q.QuestionId){
                const ques = this.form.Questions.find(qq => qq.Id == q.QuestionId)
                const quesIn = this.form.Questions.findIndex(qq => qq.Id == q.QuestionId)
                if(ques){
                    const answer = ques.AnswerOptions.find(ao => ao.AnswerOptionOfQuestionId == q.AnswerOptionOfQuestionId)
                    return answer ? `${quesIn + 1}. sorunun "${answer.Value}" cevabına bağlı.` : null
                }else return null
            }else return null
        },
        deleteQ(q){
            this.$confirm(
                "Soruyu silmek istediğinize emin misiniz?",
                `Bu işlem "${q.Title}" sorusunu silecektir. Bu işlem geri alınamaz.`
            ).then(res => {
                if(res){
                    EmployeeOperationsApi.Form.QuestionDelete(q.Id).then(res => {
                        this.$result(res)
                        if(res.data.Success){
                            this.getForm()
                        }
                    }).catch(err => {
                        this.$result(null,err)
                    })
                }
            })
        }
    },
    computed:{
        connectedQuestionAnswers(){
            if(this.form?.Questions && this.form.Questions.length >= 1){
                return this.form.Questions.reduce((arr,q,i) =>{
                    q.AnswerOptions.forEach((a) => {
                        arr.push({
                            Name:`${i + 1}. sorunun "${a.Value}" cevabı`,
                            Id:a.AnswerOptionOfQuestionId,
                            QuestionId:q.Id
                        })
                    })
                    return arr
                },[])
            }else return []
        },
        canAdd(){
            if((this.question.Title || '').trim() == "" || this.question.Title == null) return false
            else if(this.answerType == null) return false
            else {
                if(this.answerType.Code == 'CS' || this.answerType.Code == 'D'){
                    if(this.answer.length >= 2) return true
                    else return false
                }else return true
            }
        }
    }
}
</script>